export const getCurrentCampagne = state => state.currentCampagne
